import { Component, HostListener, OnInit } from '@angular/core';
import { Service } from '../service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})

export class QuestionComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  public onPageUnload($event: BeforeUnloadEvent) {
    $event.returnValue = true;

  }
  // The question, which will be displayed
  question;
  user;
  progressnumber: number = 10;
  counter: number = 0;
  isShown: boolean = false;
  radioBtnAnswer: string;
  answerIcon: boolean = false;
  answertext: boolean = false;
  descriptionText: boolean = false;
  radioChecked: string;


  // A form group used to handle the answers as option inputs
  form: FormGroup;

  constructor(
    public quiz: Service,
    public route: ActivatedRoute,
    public FB: FormBuilder,
    public router: Router,
  ) {

    // force route reload whenever params change;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    /*
      2. Subscribe to routing events. By doing so, everytime your user is being routed, an event will be triggered. Because you declared a parameter in your routes, you have a dynamic URL : this allows you to query the right question. 

      Go to question.component.html
    */


    this.route.paramMap.subscribe(params => {

      // Get the question ID and store it. 
      this.quiz.questionId = +params.get('questionId');
      console.log("Question Id: ", this.quiz.questionId);



      // If there is no more question, navigate to show the answers
      if (this.quiz.questionId > this.quiz.questions.length - 1) {
        this.router.navigate(['/summary']);
      }


      // Set the current question to be displayed and create a form group. 
      this.question = this.quiz.questions[this.quiz.questionId];
      this.form = this.FB.group({
        answer: ''
      });
    });
  }


  validateAnswer() {
    if (this.radioBtnAnswer === 'Yes' || this.radioBtnAnswer === 'Not Sure') {
      this.answerIcon = true;
      this.answertext = false;
    }
    else {
      this.answerIcon = false;
      this.answertext = false;
    }
  }

  previousQuestion() {
    this.router.navigate(['/home', 'question', this.quiz.questionId - 1]);
    // If there is no more question, navigate to show the answers
    if (this.quiz.questionId === 0) {
      this.router.navigate(['/home']);
    }
  }
  nextQuestion() {

    if (this.radioBtnAnswer == 'Yes' || this.radioBtnAnswer == 'Not Sure' || this.radioBtnAnswer == 'No' || this.radioBtnAnswer == 'N/A') {
      this.quiz.validate(this.question.id, this.question.question, this.radioBtnAnswer, this.question.description, this.question.points, this.question.descriptionPoints, this.question.header);
      this.router.navigate(['/home', 'question', this.quiz.questionId + 1]);
      this.answerIcon = false;
      this.radioBtnAnswer = '';
      this.answertext = false;
      this.descriptionText = false;

    }
    else {
      this.answertext = true;
    }
  }


  ngOnInit() {
    this.radioChecked = sessionStorage.getItem(JSON.stringify(this.quiz.questionId));
    this.radioChecked = JSON.parse(this.radioChecked);
    if (this.radioChecked) {
      this.radioChecked = this.radioChecked["answerPrem"];
      this.radioBtnAnswer = this.radioChecked;
      console.log("Session Storage: ", this.radioChecked);
    }
  }

}